import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { image } from "../../../resource";
import Text from "../../../components/Text/Text";
import Button from "../../../components/Button/Button";

const instructionSteps = [
  "1. เลือกร้านค้า ติ๊กถูกหน้ารายการร้านค้าที่ต้องการเพิ่ม หากต้องการเพิ่มให้ทุกร้าน ติ๊กถูกเลือกที่หัวตาราง",
  "2. กดปุ่ม “เพิ่มเงื่อนไขเดียวกัน”",
  "3. ระบุจำนวนที่ต้องการให้เป็นเงื่อนไขเดียวกัน",
];

const InstuctionQuotaConditions: React.FC<{ open: boolean; onClose: () => void }> = ({
  open,
  onClose,
}) => {
  const modalStyles = {
    container: {
      display: "flex",
      flexDirection: "column" as const,
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 16,
    },
    image: {
      width: 116,
      height: 116,
      marginBottom: 22,
    },
    stepWrapper: {
      marginBottom: 24,
      padding: "0 8px",
    },
    step: {
      marginBottom: 12,
    },
    buttonWrapper: {
      textAlign: "center" as const,
    },
  };
  return (
    <Modal width={400} open={open} closable={false} centered footer={null} onCancel={onClose}>
      <div style={modalStyles.container}>
        <img
          src={image.SameCondition}
          alt='Same Condition'
          draggable={false}
          style={modalStyles.image}
        />
        <Text fontSize={20} fontWeight={700}>
          ขั้นตอนเพิ่มเงื่อนไขเดียวกัน
        </Text>
      </div>

      <div style={modalStyles.stepWrapper}>
        {instructionSteps.map((step, idx) => (
          <div key={idx} style={modalStyles.step}>
            <Text
              fontFamily='Sarabun'
              fontSize={16}
              fontWeight={200}
              style={{ userSelect: "none" }}
            >
              {step}
            </Text>
          </div>
        ))}
      </div>

      <div style={modalStyles.buttonWrapper}>
        <Button title='เข้าใจแล้ว' onClick={onClose} />
      </div>
    </Modal>
  );
};

export default InstuctionQuotaConditions;
